import { render, staticRenderFns } from "./companyfullName.vue?vue&type=template&id=a2ed726a&scoped=true"
import script from "./companyfullName.vue?vue&type=script&lang=js"
export * from "./companyfullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed726a",
  null
  
)

export default component.exports